import { NavButton } from './NavButton';
import { SimpleSideNav } from './SimpleSideNav';
//import ScrollToTopButton from './ScrollToTopButton';
import { Box, useTheme } from '@mui/joy';
import { useMediaQuery } from '../../hooks/useMediaQuery';

export const SimpleNav = () => {
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.up(770)); //width at which size changes on drupal site
	const matchesMd = useMediaQuery(theme.breakpoints.up(900));
	const matchesLg = useMediaQuery(theme.breakpoints.up(1024));

	return (
		<Box
			sx={{
				position: { xs: 'absolute', md: 'fixed' },
				zIndex: 1000,
				top: { xs: '.5rem', sm: '2.4rem' },
				left: { xs: '1rem', sm: '-.5rem', md: '1rem' }
			}}
			style={{
				top: matchesLg ? '285px' : matchesMd ? '252px' : matches ? '2rem' : ''
			}} //to handle changes in size on drupal site
		>
			<NavButton />

			{/* this is only here because the scroll functionality lives in this component - it is never visible */}
			<SimpleSideNav />
			{/* only visible at 900px and above */}
		</Box>
	);
};
